<div class="p-6" data-element="mark-as-paid-dialog-container">
  <div class="flex justify-between items-center mb-6" data-element="mark-as-paid-dialog-header">
    <h3 class="m-0">Are you sure you want to mark this {{ data.type | humanize }} as paid?</h3>
    <sbnb-close (click)="dialogRef.close()" data-element="mark-as-paid-dialog-close"></sbnb-close>
  </div>
  <div class="flex flex-col gap-4 text-night" data-element="mark-as-paid-dialog-content">
    @if (isStatement) {
      <p class="m-0">
        Setting a payment date means you've paid {{ data.ownerName }} {{ data.amountOwed }} on that day. This will:
      </p>
      <ul class="list">
        <li>Mark the Statement as Paid.</li>
        <li>Reflect the full amount in your Profit & Loss Report on that date.</li>
      </ul>
    } @else {
      <p class="m-0">
        Setting a payment date means you've received {{ data.amountOwed }} from {{ data.ownerName }} on that day. This
        will:
      </p>
      <ul class="list">
        <li>Mark the Invoice as Paid.</li>
        <li>Reflect the full amount in your Profit & Loss Report on that date.</li>
      </ul>
    }
    <div class="mt-2">
      <sbnb-date-picker
        [numMonths]="1"
        [rangeSelect]="false"
        [initialDateRange]="[selectedDate, selectedDate]"
        [checkInOutStyling]="false"
        [showDurationLabels]="false"
        [preventFutureDatesSelection]="true"
        (datesSelected)="onDateSelected($event)"
        (click)="$event.stopPropagation()"></sbnb-date-picker>
    </div>

    <div class="flex justify-between mt-4">
      <ng-container *ngTemplateOutlet="nevermindButton"></ng-container>

      <sbnb-button
        label="Mark as paid"
        [disabled]="!selectedDate"
        (click)="closeDialog()"
        data-element="confirm-mark-as-paid-button"></sbnb-button>
    </div>
  </div>
</div>

<ng-template #nevermindButton>
  <sbnb-button type="secondary" label="Cancel" (click)="dialogRef.close()" data-element="cancel-button"></sbnb-button>
</ng-template>
